// =====================================================
// WeLearn Pro Player - Note module
// =====================================================

export default class Note {
    constructor(player) {
        this.player = player;
        this.courseSectionModuleId = (function () {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('csm');
        }());
    }

    getNote() {
        let self = this.player;

        $.ajax({
            url: self.options.note.get.url,
            data: {
                //VideoId: Number(self.progressData.videoId)
                CourseSectionModuleId: Number(this.courseSectionModuleId)
            },
            async: false,
            type: 'post',
            success: function (result) {
                if (self.options.debug === true) {
                    console.log("DEBUG: Note retrieval successful");
                }

                $('.ddlmemo-list').addClass('widthOpen');
                $('.overlay').addClass('active');
                $('.note-detail').remove();
                $('li.course-head.note-head').after(result);

                return true;
            },
            error: function () {
                if (self.options.debug === true) {
                    console.log("DEBUG: Note retrieval failed");
                }

                return false;
            }
        });

        this.player.event._bind_noteEvent();
    }

    /**
     * Create note at the current time of video.
     * @param time
     * @param text
     */
    createNote(text, time = this.player.plyrPlayer.currentTime) {
        let self = this.player;

        $.ajax({
            url: self.options.note.save.url,
            data: {
                //VideoId: Number(self.progressData.videoId),
                CourseSectionModuleId: Number(this.courseSectionModuleId),
                VideoId: Number(self.progressData.videoId),
                Message: text,
                Time: Math.floor(time)
            },
            async: false,
            type: 'post',
            success: function (result) {
                if (self.options.debug === true) {
                    console.log("DEBUG: Note saved successful");
                }

                $.notify("บันทึกข้อความสำเร็จ", "success");

                if ($('#note-result').length) {
                    $('#note-result').remove();
                }

                if (self.options.note.save.alert === true) {
                    $('#note-area').after(`<p id="note-result" style="color: green;">${self.options.note.save.successMessage}</p>`);

                    setTimeout(function () {
                        $('#note-result').remove();
                    }, self.options.note.save.messageTimeout);
                }

                $('#note-area').val("");

                $('.note-detail').remove();
                $('li.course-head.note-head').after(result);

                return true;
            },
            error: function () {
                if (self.options.debug === true) {
                    console.log("DEBUG: Note saved failed");
                }

                $.notify("บันทึกข้อความผิดพลาด", "error");

                if ($('#note-result').length) {
                    $('#note-result').remove();
                }

                if (self.options.note.save.alert === true) {
                    $('#note-area').after(`<p id="note-result" style="color: red;">${self.options.note.save.failureMessage}</p>`);

                    setTimeout(function () {
                        $('#note-result').remove();
                    }, self.options.note.save.messageTimeout);
                }

                return false;
            }
        });

        this.player.event._bind_noteEvent();
    }

    updateNote(noteId, message) {
        let self = this.player;

        $.ajax({
            url: self.options.note.update.url,
            data: {
                NoteId: noteId,
                CourseSectionModuleId: Number(this.courseSectionModuleId),
                Message: message
            },
            async: false,
            type: 'post',
            success: function (result) {
                if (self.options.debug === true) {
                    console.log("DEBUG: Note edit successful");
                }

                $.notify("แก้ไขข้อความสำเร็จ", "success");

                $('.note-detail').remove();
                $('li.course-head.note-head').after(result);

                return true;
            },
            error: function () {
                if (self.options.debug === true) {
                    console.log("DEBUG: Note edit failed");
                }

                $.notify("แก้ไขข้อความผิดพลาด", "error");

                return false;
            }
        });

        this.player.event._bind_noteEvent();
    }

    deleteNote(noteId) {
        let self = this.player;

        $.ajax({
            url: self.options.note.delete.url,
            data: {
                NoteId: noteId,
                CourseSectionModuleId: Number(this.courseSectionModuleId)
            },
            async: false,
            type: 'post',
            success: function (result) {
                if (self.options.debug === true) {
                    console.log("DEBUG: Note edit successful");
                }

                $.notify("ลบข้อความสำเร็จ", "success");

                $('.note-detail').remove();
                $('li.course-head.note-head').after(result);

                return true;
            },
            error: function () {
                if (self.options.debug === true) {
                    console.log("DEBUG: Note edit failed");
                }

                $.notify("ลบข้อความผิดพลาด", "error");

                return false;
            }
        });

        this.player.event._bind_noteEvent();
    }

    /**
     * Seek video to specific time.
     * @param time - Time of video.
     * @param useSeekableOption - Apply 'seekable' rule from video option.
     */
    seekTo(time, useSeekableOption = false) {
        let self = this.player;

        if (useSeekableOption) {
            switch (self.options.seekable) {
                case true:
                    self.plyrPlayer.currentTime = time;
                    return true;

                case false: // TODO : Quick changes by changing Seekable: false behavior from complete unseekable -> seekable only watched
                    let barTime = Math.floor(time);
                    if ($(`span.tick[data-timestamp='${barTime}']`).hasClass('watched') || (barTime === 0)) {
                        self.plyrPlayer.currentTime = time;
                        return true;
                    } else {
                        //self.invokeAlert('ขออภัย คุณสามารถกรอได้เฉพาะส่วนที่ดูไปแล้ว', 3000);
                        self.invokeAlert($.i18n("seekWatched"), 3000);
                        return false;
                    }

                default:
                    //self.invokeAlert('ขออภัย วิดีโอนี้ถูกตั้งค่าให้ไม่สามารถกรอวิดีโอได้', 3000);
                    self.invokeAlert($.i18n('seekDisallowed'), 3000);
                    return false;
            }
        } else {
            self.plyrPlayer.currentTime = time;
            return true;
        }
    }
}
